/**
 * Created by Samyan Wahla on 9/3/2015.
 */
(function () {
    'use strict';

    angular
        .module('tmx-app')
        .controller('resetpasswordCtrl', ['$state','$scope','$http','ENV','$location','$mdToast','ServerExceptionService',
            function ($state,$scope,$http,ENV,$location,$mdToast,ServerExceptionService) {

////////////  WATCHING FOR CHANGES IN THE ERROR in HTTP RESPONSE IN REGISTER/////////////////////////////////////
//////////////////////////Developed By Anam Farrukh//////////////////////////////////////////////////////////////
                $scope.$watch(function () { return ServerExceptionService.Displaymsg}, function (newVal, oldVal) {
                    if($scope.watch_count > 1) {
                        return;
                    }

                    if (typeof newVal !== 'undefined' && $scope.watch_count == 1) {
                        $scope.error = ServerExceptionService.Displaymsg;
                        $scope.dataLoading = false; // remove the loading imaging when error is displayed
                        $scope.watch_count = $scope.watch_count+1;
                        ServerExceptionService.Displaymsg = oldVal;//to differentiate old value from new value when user signs
                        // in multiple time using incorrect username and password and the server returns the same error
                        $scope.$on("$destroy", function(){
                            ServerExceptionService.Displaymsg = "";
                        });
                    }
                });
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                var searchObject = $location.search();

                $scope.submit = function () {
                    $scope.dataLoading = true;
                    $scope.watch_count = 1;
                    // OAuth.isAuthenticated();
                    $scope.error="";
                    $scope.userData.Id=searchObject.userId;
                    $scope.userData.Code=searchObject.code;
                    $http.post(ENV.AuthServer+'/api/Account/ResetPassword', $scope.userData).then(handleSuccess);
                };


                function handleSuccess() {
                    $scope.dataLoading = false;
                    $scope.form.$setPristine();
                    $scope.form.$setUntouched();

                    $mdToast.show(
                        $mdToast.simple()
                            .content('Your password has been reset successfully')
                            .position('top right')
                            .hideDelay(6000)
                    );

                    /////////////////////////REDIRECTION AFTER SUCCESSFULL RESET////////////////////////////////////////
                    $state.transitionTo('public.login');

                    $scope.userData={};
                    /////////////////////////REDIRECTION AFTER SUCCESSFULL RESET////////////////////////////////////////
                } //end of handleSuccess function


               // function handleError(data)
               // {
               //     $scope.dataLoading = false;
               //     $scope.error= data.data;
               //if(data.data == null)
               //{
               //    $scope.error = "Error";
               //}
               //
               // }


            }]);


})();